import { AutogenModelPnnTranscoreUser, AutogenRowPnnTranscoreUser } from "./autogen/AutogenModelPnnTranscoreUser";

export class ModelPnnTranscoreUser extends AutogenModelPnnTranscoreUser<RowPnnTranscoreUser> {
	constructor() {
		super(RowPnnTranscoreUser);
	}
}

export class RowPnnTranscoreUser extends AutogenRowPnnTranscoreUser {
}